import { StyledCell } from '../Row.style';

const FteCostCell = ({ raCost, period, effortFte }) => {
  const amount = raCost.calculateCostByFte({ period, effortFte });
  const amountString = raCost.formatToString(amount, {
    round: 1,
    kFormat: true
  });
  return <StyledCell>{amountString}</StyledCell>;
};

export default FteCostCell;
